import { Component, Input, OnInit } from '@angular/core'

@Component({
  selector: 'dmmp-list',
  templateUrl: './list.component.html'
})
export class ListComponent implements OnInit {
  @Input() data
  constructor() {}

  ngOnInit() {}
}
